/**
 * Console entry point for the device content escrow (core-content cutover).
 *
 * installContentEscrow() attaches the exporter to
 * window.__ADIA_CONTENT_ESCROW__ so an operator sitting at a real device can
 * run it from DevTools during the cutover window, per
 * docs/runbooks/core-content-cutover.md:
 *
 *   await window.__ADIA_CONTENT_ESCROW__.export({
 *     contextId: 'phone-a-ledger-context',
 *     contextLabel: 'phone-a',
 *     passphrase: '<typed, never pasted into a log>',
 *   })
 *
 * The exporter is strictly read-only (see export.ts), so exposing it is safe
 * even while the app is in core-content read-only mode. It is deliberately NOT
 * wired into main.tsx here: the integration phase owns that call site.
 */

import { ARCHIVE_VERSION } from './types';
import { exportEscrow, verifySemanticEmptyContext } from './export';

export interface ContentEscrowGlobal {
  export: typeof exportEscrow;
  verifySemanticEmpty: typeof verifySemanticEmptyContext;
  version: typeof ARCHIVE_VERSION;
}

declare global {
  interface Window {
    __ADIA_CONTENT_ESCROW__?: ContentEscrowGlobal;
  }
}

export function installContentEscrow(): void {
  if (typeof window === 'undefined') return;
  window.__ADIA_CONTENT_ESCROW__ = {
    export: exportEscrow,
    verifySemanticEmpty: verifySemanticEmptyContext,
    version: ARCHIVE_VERSION,
  };
}
